'use strict'

import { Puzzle } from './puzzle.js'
import { Grid } from './grid.js'

export class Crossword extends Puzzle {
  constructor (data = new Uint8Array()) {
    super(data)

    this._data = data

    this.puzzleStates = {}
    this.grid = new Grid()
    this.clues = []
    this.axes = []

    this._blockchr = '.'
  }

  /**
   * Import a file.
   *
   * @param file [Buffer] The file must be an array of DEC bytes.
   *  Can be a Nodejs Buffer, Uint8Array, or even a normal Array.
   */
  importPuzzle (file) {
    this._data = file

    this._parsePuzzle()

    return this
  }

  /**
   * Get clues by axis.
   *
   * @param axis [String] the clue axis.
   *
   * @return [<Clue...>]
   */
  cluesByAxis (axis) {
    return this.clues.filter(clue => {
      return clue.axis === axis
    })
  }

  get dims () {
    return this.grid.height + 'x' + this.grid.width
  }

  get height () {
    return this.grid.height
  }

  get width () {
    return this.grid.width
  }

  set grid (value) {
    this['_grid'] = value
  }

  get grid () {
    return this['_grid']
  }

  set clues (value) {
    this['_clues'] = value
  }

  get clues () {
    return this['_clues']
  }

  set axes (value) {
    this['_axes'] = value.sort()
    this.grid.axes = this['_axes']
  }

  get axes () {
    return this['_axes']
  }

  set puzzleStates (value) {
    this['_puzzleStates'] = value
  }

  get puzzleStates () {
    return this['_puzzleStates']
  }

  get words () {
    return this['_words']
  }

  set words (value) {
    this['_words'] = value
  }

  /* Protected methods */

  _isAcross (axis) {
    return axis === 'across'
  }

  /**
   * Verify whether the passed character is considered a block character.
   *
   * @param chr [String]
   *
   * @return [Boolean] denoting whether the passed character is a block
   *  character or not.
   */
  _isBlockChr (chr) {
    return chr === this._blockchr
  }

  _isDown (axis) {
    return axis === 'down'
  }

  /* Gets the next expected grid cell.
  *
  * @param idx [Number] the cell index value
  * @param axis [String] the active axis
  *
  * @return [Cell]
  */
  _nextCell (idx, axis) {
    const offset = this._isAcross(axis) ? 1 : (this.width)

    let nextCellIdx = idx + offset

    return this.grid.cellByIdx(nextCellIdx)
  }

  _setClueCells () {
    let cell, cellIdx, clue
    for (let i in this.grid.cells) {
      for (let j in this.grid.cells[i].clues) {
        clue = this.grid.cells[i].clues[j]

        cellIdx = clue.idx
        this.clues[j].cells.push(cellIdx)
        while (cell) {
          cell = this._nextCell(cellIdx, clue.axis)
          if (cell.isBlock) {
            break
          }

          cellIdx = cell.idx
          this.clues[j].cells.push(cellIdx)

          if (!this.grid.cells[i].clues.includes(clue)) {
            this.grid.cells[i].clues.push(clue)
          }
        }
      }
    }
  }

  // Sets the cell numbers for the cells in the grid.
  _setCellNumbers () {
    let cell
    let num = 1

    for (let i = 0, len = this.grid.cells.length; i < len; i++) {
      let across, down, x, y

      cell = this.grid.cells[i]
      x = cell.x
      y = cell.y

      // Ignore cell if it doesn't have an answer.
      if (!this.grid.cellHasAnswer(x, y)) { continue }

      // Check if the current cell starts an across clue.
      if (
        (x === 0 || this.grid.cellIsNullOrBlock(x - 1, y)) &&
        (x + 1 < this.grid.width) &&
        this.grid.cellHasAnswer(x + 1, y)
      ) {
        across = true
      }

      // Check if the current cell starts a down clue.
      if (
        (y === 0 || this.grid.cellIsNullOrBlock(x, y - 1)) &&
        (y + 1 < this.grid.height) &&
        this.grid.cellHasAnswer(x, y + 1)
      ) {
        down = true
      }

      // Set the clue number to the current cell, if necessary.
      if (down || across) {
        this.grid.cells[i].cellNumber = num
        if (across) { this.grid.cells[i].axes.push('across') }
        if (down) { this.grid.cells[i].axes.push('down') }

        num += 1
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/crossword.js
// module id = 103
// module chunks = 0